// extracted by mini-css-extract-plugin
export default {"questionMark":"QuestionMarkIcon_questionMark__q9D2T"};